import React from "react";
import { Home } from "pages";

const HomeRoute = () => {
  return (
    <>
      <Home />
    </>
  );
};

export default HomeRoute;
